import React from 'react'

export function PlusIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="9" r="8.25" stroke="#484C67" strokeWidth="1.5"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M10 8V5H8V8H5V10H8V13H10V10H13V8H10Z" fill="#484C67"/>
    </svg>
  )
}